<template>
    <div class="newsletter">
        <form @submit.prevent="signup()">

            <div class="row p-0" v-if="!success">
                <div class="col-md-3 p-1">
                    <label class="sr-only" for="newslettername">Full Name</label>

                    <input type="text" class="form-control form-control-sm" id="newslettername" name="name" placeholder="Full Name*" v-model="name"
                           :class="{'is-invalid': hasError('name')}">

                </div>

                <div class="col-md-4 p-1">
                    <label class="sr-only" for="newsletterEmail">Email</label>

                    <input type="text" class="form-control form-control-sm" id="newsletterEmail" name="email" placeholder="Email Address*" v-model="email"
                           :class="{'is-invalid': hasError('email')}">


                </div>

                <div class="col-md-3 p-1">
                    <label class="sr-only" for="newsletterPhoneNumber">Phone Number</label>
                    <input type="text" class="form-control form-control-sm" id="newsletterPhoneNumber" placeholder="Phone Number" name="phone_number" v-model="phone">
                </div>

                <div class="col-md-2 p-1">
                    <button type="submit" class="btn btn-danger" v-if="!processing">Submit</button>
                    <button type="submit" class="btn btn-danger" disabled="true" v-if="processing">Processing...</button>
                </div>
            </div>
                <div class="row text text-danger" v-if="errors && !success">
                    Error: You must enter your name and a valid email address
            </div>
        </form>

        <div class="text thank-you" v-if="success">
            <h2>Thank You!</h2>
            <p>Your information was successfully submitted! We look forward to shopping with you.</p>
        </div>
    </div>
</template>

<script>
    import {ServiceFactory} from '../../../../../../shared/assets/js/services/ServiceFactory';
    const NewsletterSignupService = ServiceFactory.get('newsletterSignup');

    export default {
        data() {
            return {
                name: '',
                phone: '',
                email: '',
                success: false,
                errors: null,
                processing: false,
            }
        },

        methods: {
            async signup() {
                try {
                    this.processing = true;
                    await NewsletterSignupService.add(this.name, this.email, this.phone);

                    this.success = true;
                    this.name = '';
                    this.phone = '';
                    this.email = '';
                    this.processing = false;
                } catch (error) {
                    this.errors = error.response.data;
                    this.processing = false;
                }
            },

            hasError(field) {

                if (this.errors === null) {
                    return false;
                }

                if (this.errors[field]) {
                    return true;
                }

                return false;
            },

        },
    }
</script>
